import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { CertificationType } from '../certification-type.model';

export enum CertificationTypeActionTypes {
  LoadCertificationTypes = '[CertificationTypes] Load',
  LoadCertificationTypesSuccess = '[CertificationTypes] Load success',
  LoadCertificationTypesFail = '[CertificationTypes] Load fail',
}

@ShowLoader()
export class LoadCertificationTypes implements Action {
  readonly type = CertificationTypeActionTypes.LoadCertificationTypes;
}
@HideLoader(CertificationTypeActionTypes.LoadCertificationTypes)
export class LoadCertificationTypesSuccess implements Action {
  readonly type = CertificationTypeActionTypes.LoadCertificationTypesSuccess;
  constructor(public payload: CertificationType[]) { }
}
@HideLoader(CertificationTypeActionTypes.LoadCertificationTypes)
export class LoadCertificationTypesFail implements Action {
  readonly type = CertificationTypeActionTypes.LoadCertificationTypesFail;
  constructor(public payload: string) { }
}


export type CertificationTypeActions = LoadCertificationTypes | LoadCertificationTypesSuccess | LoadCertificationTypesFail;
